<template>
  <div class="Products">
    <section class="py-32 bg-white">
      <div class="container mx-auto px-4">
        <div class="flex flex-col lg:flex-row gap-8">
          <!-- Left Side: Product Categories (Navigation)
          :selectedCategory="selectedCategory"
              @category-selected="selectCategory"
              @price-filter-updated="handlePriceFilterUpdate" -->
          <div class="lg:w-1/4">
            <product-categories
              :categories="categories"
              :activeCategorie="activeCategorie"
              @category-click="handleCategorieClick"
            />
          </div>
          <div class="lg:w-3/4" v-show="showProductList">
            <!-- 产品列表 -->
            <product-list
              :productListPics="productListPics"
              @list-click="handleListClick"
            ></product-list>
          </div>
          <!-- Right Side: Product Display -->
          <div class="lg:w-3/4" v-show="!showProductList">
            <!-- 产品细节 -->
            <!-- Top: Product Image Display (Combined thumbnails and main image) -->
            <div class="bg-white rounded-lg shadow-lg p-6 mb-8">
              <!-- <div v-if="selectedProduct"> -->
              <!-- 产品图片 -->
              <product-images :productDetailPics="productDetailPics" />
              <!-- </div> -->
              <!-- <div v-else class="text-center py-20">
                <div class="text-6xl text-gray-300 mb-4">
                  <i class="fa fa-picture-o"></i>
                </div>
                <p class="text-gray-600">Select a product to view details</p>
              </div> -->
            </div>

            <!-- Bottom: Product Description -->
            <!-- <div v-if="selectedProduct"> -->
            <product-description
              :productListPics="productListPics"
              :showPic="productDetailPics"
              @list-click="handleListClick"
            />
            <!-- </div> -->
          </div>

          <!-- <product-description :product="selectedProduct" /> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ProductCategories from './ProductCategories'
import ProductList from './ProductList'
import ProductImages from './ProductImages'
import ProductDescription from './ProductDescription'
export default {
  name: 'ProductsN',
  components: {
    ProductCategories,
    ProductList,
    ProductImages,
    ProductDescription
  },
  data() {
    return {
      categories: [],
      selectedCategory: 'Keychain',
      selectedProduct: null,
      showProductList: true,
      productListPics: [],
      productDetailPics: [],
      activeCategorie: ''
    }
  },
  computed: {},
  created() {},
  activated() {
    // this.categories = []
    const categorie = this.$route.query.category
    this.activeCategorie = categorie
    window.scrollTo(0, 0)
    // this.loadCategories()
  },
  mounted() {
    // const categorie = this.$route.query.category
    // this.activeCategorie = categorie
    window.scrollTo(0, 0)
    this.loadCategories()
  },
  methods: {
    // 类目选中事件
    handleCategorieClick(item, subItem) {
      // 加载图片
      if (!subItem) {
        subItem = ''
      }

      window.scrollTo(0, 0)
      this.loadPicName(item.category, subItem)
    },
    // 列表点击事件
    handleListClick(product) {
      window.scrollTo(0, 0)
      // console.log(JSON.stringify(product))
      let prePath = product.picPath.split('-1.jpg')[0]
      let arr = []
      for (let i = 1; i < 5; i++) {
        arr.push({
          picPath: prePath + '-' + i + '.jpg',
          category: product.category,
          subCategory: product.subCategory
        })
      }
      this.showProductList = false
      this.productDetailPics = arr
    },
    // 获取类目
    loadCategories() {
      this.$api.sysApi.getCategories().then((res) => {
        this.categories = res.data
      })
    },
    // 获取类目图片名称
    loadPicName(category, subCategory) {
      if (category.indexOf('&') > -1) {
        category = category.replace('&', '*')
      }
      this.activeThumbnail = 0
      this.productListPics = []
      let path = `https://pic.deergifts.com/${category}/`
      if (subCategory) {
        path += `${subCategory}/`
      }
      this.$api.sysApi.getPicName(category, subCategory).then((res) => {
        // 当图片名称数量>4的时候，需要展示list,否则直接显示详细
        if (res.data.length > 4) {
          this.showProductList = true
          // 显示list
          const arr = []
          const listArr = this.checkEndWithStr(res.data)
          for (let i = 0; i < listArr.length; i++) {
            arr.push({
              picPath: path + listArr[i],
              category: category,
              subCategory: subCategory
            })
          }
          this.productListPics = arr
        } else {
          // 显示详情
          if (category.indexOf('*') > -1) {
            category = category.replace('*', '&')
            path = path.replace('*', '&')
          }
          this.showProductList = false
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              picPath: path + res.data[i],
              category: category,
              subCategory: subCategory
            })
          }

          this.productListPics = []
          this.productDetailPics = arr
          // console.log(JSON.stringify(this.productDetailPics))
        }
      })
    },
    // 找出第一个图片，作为list展示
    checkEndWithStr(arr) {
      const suffix = '-1.jpg'
      const pattern = new RegExp(suffix + '$', 'i')

      // 使用 filter 方法筛选匹配的元素
      return arr.filter((item) => {
        // 确保 item 是字符串类型
        if (typeof item !== 'string') return false
        // 测试是否匹配正则表达式
        return pattern.test(item)
      })
    }
  }
}
// {
//   'picPath': '',
//   'picList': [],
//   'subCategory': '',
//   'subCategory': '',
// }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Products {
  min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/page/products/ProductsN.vue